export default __webpack_public_path__ + "static/media/zoomapp.50686548.png";